import * as CONST from '../ActionTypes';

const initialState = {
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  companyFAQ: {},
  companyFAQList: [],
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
  },
};

function companyFAQ(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // FAQ情報一覧取得
    // -----------------
    case CONST.GET_COMPANY_FAQ_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          companyFAQList: action.payload,
        },
      );
    case CONST.GET_COMPANY_FAQ_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isFailure: true,
          companyFAQList: {},
        },
      );
    // -----------------
    // FAQ詳細取得
    // -----------------
    case CONST.GET_COMPANY_FAQ_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          companyFAQ: action.payload,
        },
      );
    case CONST.GET_COMPANY_FAQ_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          companyFAQ: {},
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_COMPANY_FAQ_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default companyFAQ;
